import { useEffect, useRef } from 'react'

import { useCart } from '../contexts/CartContext'
import { useOrder } from '../contexts/OrderContext'
import {
  getCartSubTotal,
  getCouponCodeForValidation,
  validateCouponCode,
} from '../utils/coupon'

const cartFingerprint = (cart) =>
  (cart || []).map((item) => `${item.prodId}:${item.count}:${item.price}`).join('|')

/** Re-validate applied coupon when cart lines or quantities change. */
export const useSyncCouponWithCart = () => {
  const [cart] = useCart()
  const [orderDetail, { updateOrder }] = useOrder()
  const requestIdRef = useRef(0)
  const cartKey = cartFingerprint(cart)

  useEffect(() => {
    const coupon = orderDetail?.coupon
    const code = getCouponCodeForValidation(coupon)
    if (!coupon || !code) return

    const subTotal = getCartSubTotal(cart)
    const requestId = ++requestIdRef.current

    const timer = setTimeout(async () => {
      try {
        const validated = await validateCouponCode(code, subTotal)
        if (requestId !== requestIdRef.current) return

        if (!validated) {
          updateOrder({ coupon: null, promoCodeError: true })
          return
        }

        const discountUnchanged =
          coupon.couponId === validated.couponId &&
          Number(coupon.discountAmount) === Number(validated.discountAmount)

        if (!discountUnchanged) {
          updateOrder({ coupon: validated, promoCodeError: false })
        }
      } catch (err) {
        if (requestId !== requestIdRef.current) return
        console.log(err, 'coupon revalidate error')
        updateOrder({ coupon: null, promoCodeError: true })
      }
    }, 400)

    return () => {
      clearTimeout(timer)
      requestIdRef.current += 1
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- re-run only when cart contents change
  }, [cartKey])
}
